// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_ROOVN","startPage":"style_startPage_eV9zE"};